import { Dispatch, FC, SetStateAction, useEffect } from "react";
import AccessRights from "../../../../components/AccessRights/AccessRights";
import Form from "../../../../components/Form/Form";
import { ValidatorsE } from "../../../../components/Form/yupValidations";
import { Span } from "../../../../components/Text/Text";
import {
  FileTypeE,
  FileTypeHebrewE,
  LangE,
  UserRoleE,
} from "../../../../models/enums";
import { FormFieldT, SelectOptionT } from "../../../../models/models";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCurrentLang } from "../../../../store/selectors/appSelectors";
import {
  fileTypeHebrewSO,
  fileTypeSO,
  selectValue,
} from "../../../../utils/helpers/selectOptions";
import { clss } from "../../../../utils/helpers/styleHelpers";
import { selectStyles } from "../selectStyles";
import {
  setHouseNumber as setHouseNumberAction,
  setSponsorshipHouseNumber as setSponsorshipHouseNumberAction,
} from "../../../../store/slices/deliveryWizardSlice";

import styles from "./styles.module.scss";

type BroadcasterHouseNumbersPropTypes = {
  houseNumber: string;
  setHouseNumber: Dispatch<SetStateAction<string>>;
  sponsorshipHouseNumber: string;
  setSponsorshipHouseNumber: Dispatch<SetStateAction<string>>;
  useFor2Spots: boolean;
  isEditMode?: boolean;
  SecondHouseNumberType?: number;
  setSecondHouseNumberType: (option: SelectOptionT) => void;
};

const BroadcasterHouseNumbers: FC<BroadcasterHouseNumbersPropTypes> = (
  props
) => {
  const {
    houseNumber,
    sponsorshipHouseNumber,
    setHouseNumber,
    setSponsorshipHouseNumber,
    isEditMode,
    useFor2Spots,
    SecondHouseNumberType,
    setSecondHouseNumberType,
  } = props;
  const lang = useAppSelector(selectCurrentLang);
  const dispatch = useAppDispatch();

  const handleChangeHouseNumber = (value: string) => {
    setHouseNumber(value);
    dispatch(setHouseNumberAction(value));
  };

  const handleChangeSponsorshipHouseNumber = (value: string) => {
    setSponsorshipHouseNumber(value);
    dispatch(setSponsorshipHouseNumberAction(value));
  };

  const fields: FormFieldT[] = [
    {
      label: "House num:",
      defaultValue: houseNumber,
      validation: ValidatorsE.CAPITAL_LATIN_AND_NUMBERS,
      onChange: handleChangeHouseNumber,
      capitalLetters: true,
      onlyLettersAndNumbers: true,
    },
    {
      label: "Sponsorship house num:",
      defaultValue: sponsorshipHouseNumber,
      validation: ValidatorsE.CAPITAL_LATIN_AND_NUMBERS,
      onChange: handleChangeSponsorshipHouseNumber,
      props: {
        disabled: !useFor2Spots,
      },
      capitalLetters: true,
      onlyLettersAndNumbers: true,
    },
    {
      label: "Sponsorship content type:",
      selectOptions: lang === LangE.EN ? fileTypeSO : fileTypeHebrewSO,
      defaultValue: selectValue(
        lang === LangE.EN ? fileTypeSO : fileTypeHebrewSO,
        SecondHouseNumberType || FileTypeE.Sponsorship
      ),
      onChange: (option) => setSecondHouseNumberType(option),
      props: {
        disabled: !useFor2Spots,
      },
      customSelectPropsStyles: selectStyles as any,
    },
  ];

  const handleSubmit = (data: any) => {
    // required
  };

  return (
    <AccessRights accessFor={[UserRoleE.Broadcaster]}>
      {isEditMode ? (
        <div className={clss([styles.wrapper, styles.editableWrapper])}>
          <Form
            fields={fields}
            onSubmit={handleSubmit}
            formID={"house-numbers"}
            className={styles.formWrapper}
          />
        </div>
      ) : (
        (houseNumber || (useFor2Spots && sponsorshipHouseNumber)) && (
          <div className={clss([styles.wrapper, styles.displayWrapper])}>
            {houseNumber && (
              <span>
                <Span>House number</Span>: <strong>{houseNumber}</strong>
              </span>
            )}
            {useFor2Spots && (
              <span>
                <Span>Sponsorship house number</Span>:{" "}
                <strong>{sponsorshipHouseNumber}</strong>
              </span>
            )}
            {useFor2Spots && (
              <span>
                <Span>Sponsorship content type</Span>:{" "}
                <strong>
                  {
                    (lang === LangE.EN ? FileTypeE : FileTypeHebrewE)[
                      SecondHouseNumberType
                    ]
                  }
                </strong>
              </span>
            )}
          </div>
        )
      )}
    </AccessRights>
  );
};

export default BroadcasterHouseNumbers;
